import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Message from '../common/message/Message';
import {ProgressItem} from './ProgressItem';
import { ProgText } from './ProgText';

import { PROGRESS } from '../../constants/ProgressStates';
import {generateURLParam} from '../../utils/Utils';

const renderContent = (offlinePayment, status, isCash) => {
    const location = generateURLParam('tab', 'tax_profile');
    if (offlinePayment) {
        if (status === PROGRESS.ACTIVE) {
            if (!isCash) {
                return <ProgText code="epic.esport.step3.pg.content" args={[location]} />;
            }
            return <ProgText code="epic.esport.step3.direct.content" />;
        }
        if (status === PROGRESS.COMPLETE) {
            return <ProgText code="epic.esport.step3.direct.complete.content" />;
        }
    }

    if (status === PROGRESS.INCOMPLETE) {
        return <ProgText code="epic.esport.step3.incomplete.content" />;
    }
    if (status === PROGRESS.COMPLETE) {
        if (!isCash) {
            return <ProgText code="epic.esport.step3.pg.content" args={[location]} />;
        }
        return <ProgText code="epic.esport.step3.complete.content" />;
    }

    if (!isCash) {
        return (
            <Fragment>
                <ProgText code="epic.esport.step3.pg.content" args={[location]} />
            </Fragment>
        );
    }

    // PROGRESS.ACTIVE
    return (
        <Fragment>
            <ProgText code="epic.esport.step3.content1" />
            <ProgText code="epic.esport.step3.content2" />
        </Fragment>
    );
};

export const Step3 = ({status, isCash, offlinePayment, ...otherProps}) => {
    const titleCode = status === PROGRESS.ACTIVE ? 'epic.esport.step3.title' : 'epic.esport.step3.incomplete.title';

    return (
        <ProgressItem
            title={<Message fragment code={titleCode} />}
            step={3}
            status={status}
            {...otherProps}
        >
            {renderContent(offlinePayment, status, isCash)}
        </ProgressItem>
    );
};

Step3.displayName = 'Step3';

Step3.propTypes = {
    offlinePayment: PropTypes.bool,
    status: PropTypes.oneOf(Object.values(PROGRESS)),
    isCash: PropTypes.bool
};
